import { useState, useEffect } from 'react';
import { parseDropdownData } from './parser';
import { useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import {
  getSingleCompaniesDetailsService,
  updateCompaniesDetailsService,
  updateCompanyStatusService,
} from '../../services/companyService';
import { getAllAreaOfContentService } from '../../services/areaOfContentService';
import { uploadImageService } from '../../services/uploadService';
import { cloneDeep } from 'lodash';

import Header from '../../components/Header';
import Input from '../../components/Input';
import Sidebar from '../../components/Sidebar';
import Spinner from '../../components/Spinner';
import TextArea from '../../components/TextArea';
import SubHeader from '../../components/SubHeader';
import PrimaryButton from '../../components/PrimaryButton';
import DropdownSelect from '../../components/DropdownSelect';
import MultiDropdownSelect from '../../components/MultiDropdownSelect';

import Placeholder from '../../assets/images/placeholder.webp';
import './styles.scss';
import SecondaryButton from '../../components/SecondaryButton';

const dashboardVisibleStatus = [
  {
    name: 'Yes',
    value: true,
  },
  {
    name: 'No',
    value: false,
  },
];

const autoPremiumStatus = [
  {
    name: 'Yes',
    value: true,
  },
  {
    name: 'No',
    value: false,
  },
];

const listingOptions = [
  {
    name: 'Active',
    value: 'ACTIVE',
  },
  {
    name: 'Inactive',
    value: 'INACTIVE',
  },
];

const EditCompanies = (props) => {
  const history = useHistory();
  let hasDetailsFetched = false;

  const { addToast } = useToasts();

  const [file, setFile] = useState(null);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [companyStatus, setCompanyStatus] = useState('');
  const [subDomain, setSubDomain] = useState('');
  const [aocOptions, setAocOptions] = useState([]);
  const [premium, setPremium] = useState('');
  const [coupon, setCoupon] = useState('');
  const [dashboardVisible, setDashboardVisible] = useState('');
  const [selectedAocOptions, updateSelectedAocOptions] = useState([]);
  const [companyIdentifier, setCompanyIdentifier] = useState('');
  const [hasFileModified, setFileModified] = useState(false);
  const [companyImageIdentifier, setCompanyImageIdentifier] = useState('');
  const [currentPage, setCurrentPage] = useState(null);

  const userData = {
    userName: 'Admin',
  };

  //paging
  useEffect(() => {
    setCurrentPage(props.location.state.page_number);
  }, []);

  useEffect(() => {
    const companyID = props?.match?.params?.editCompanyIdentifier;
    setCompanyIdentifier(companyID);
  }, []);

  // Acting ComponentDidUpdate
  useEffect(() => {
    if (companyIdentifier && companyIdentifier !== null && !hasDetailsFetched) {
      hasDetailsFetched = true; // eslint-disable-line

      fetchPrefillData();
    }
  }, [companyIdentifier]);

  const fetchPrefillData = () => {
    setLoading(true);

    getSingleCompaniesDetailsService(companyIdentifier)
      .then((response) => {
        setLoading(false);

        if (response.code === 200) {
          const { data } = response;
          let tempArr = [];
          if (data?.aocs) {
            data?.aocs.map((item) => {
              tempArr.push(item.id);
            });
          }
          setImage(response.data?.image?.url);
          setCompanyImageIdentifier(response.data?.image?.id);
          setCompanyName(data?.name);
          setSubDomain(data?.subDomain);
          setCompanyStatus(data?.status);
          setCoupon(data?.membershipCode);
          setDashboardVisible(data?.isDashboardVisible);
          setPremium(data?.autoPremium);
          updateSelectedAocOptions(tempArr);
        }
      })
      .catch((err) => {
        addToast(err.response?.data?.message, {
          appearance: 'error',
          autoDismiss: true,
        });

        setLoading(false);
      });
  };

  const fetchAOCData = (params) => {
    setLoading(true);

    getAllAreaOfContentService(params)
      .then((response) => {
        setLoading(false);

        if (response.code === 200) {
          setAocOptions(response?.data?.results);
        }
      })
      .catch((errorData) => {
        setLoading(false);
        addToast('An error occurred while trying to Get Options.', {
          appearance: 'error',
          autoDismiss: true,
        });
      });
  };

  useEffect(() => {
    const aocParams = { page: 1, limit: 100 };

    fetchAOCData(aocParams);
  }, []); // eslint-disable-line

  const handleFieldUpdate = (fieldName, fieldValue) => {
    if (fieldName === 'companyName') {
      setCompanyName(fieldValue);
    } else if (fieldName === 'companySubdomain') {
      setSubDomain(fieldValue);
    } else if (fieldName === 'couponCode') {
      setCoupon(fieldValue);
    }
  };

  const handleAocSelection = (obj) => {
    const index = selectedAocOptions.findIndex((el) => el === obj.id);
    const tempArr = cloneDeep(selectedAocOptions);
    if (index === -1) {
      tempArr.push(obj.id);
    } else {
      tempArr.splice(index, 1);
    }
    updateSelectedAocOptions(tempArr);
  };

  const handleStatusSelection = (eventValue) => {
    if (eventValue) {
      setCompanyStatus(eventValue);
    }
  };

  const handleDashboardVisible = (eventValue) => {
    if (eventValue) {
      setDashboardVisible(eventValue);
    }
  };

  const handleAutoPremium = (eventValue) => {
    if (eventValue) {
      setPremium(eventValue);
    }
  };

  const handleImageSelection = (name, targetValue, event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];

      setFile(file);

      setImage(URL.createObjectURL(file));

      setFileModified(true);
    }
  };

  const uploadImage = () => {
    setLoading(true);

    return uploadImageService(file)
      .then((response) => {
        setLoading(false);

        if (response) {
          if (response.code === 200) {
            return response;
          }
        }
      })
      .catch((errorData) => {
        setLoading(false);
        addToast('An error occurred while trying to upload file.', {
          appearance: 'error',
          autoDismiss: true,
        });

        throw errorData;
      });
  };

  const validateFormSubmission = () => {
    let isFormValid = true;

    if ((!file || !image) && hasFileModified) {
      addToast('Company photo is a required field. Please upload a photo.', {
        appearance: 'error',
        autoDismiss: true,
      });

      isFormValid = false;
    } else if (!companyName) {
      addToast('Company Name is a required field. Please provide a value.', {
        appearance: 'error',
        autoDismiss: true,
      });

      isFormValid = false;
    } else if (!subDomain) {
      addToast('Sub Domain is a required field. Please provide a value.', {
        appearance: 'error',
        autoDismiss: true,
      });

      isFormValid = false;
    } else if (!coupon) {
      addToast('Unique code should not be empty.', {
        appearance: 'error',
        autoDismiss: true,
      });

      isFormValid = false;
    }
    // else if (!companyStatus || companyStatus === '') {
    //   addToast('Company status is a required selection.', {
    //     appearance: 'error',
    //     autoDismiss: true,
    //   });

    //   isFormValid = false;
    // }
    // else if (!selectedAocOptions.length) {
    //   addToast('Area Of Content is a required selection.', {
    //     appearance: 'error',
    //     autoDismiss: true,
    //   });

    //   isFormValid = false;
    // }
    return isFormValid;
  };

  //Submit Information
  const submitCompanyDetails = (dataPayload) => {
    updateCompaniesDetailsService(companyIdentifier, dataPayload)
      .then((responseData) => {
        if (responseData.code === 200 || responseData.code === 204) {
          addToast('Company Updated successfully.', {
            appearance: 'success',
            autoDismiss: true,
          });

          // history.push('/companies');
        }
        history.push('/companies', { page_current: currentPage });
        setLoading(false);
      })
      .catch((err) => {
        const errorData = err.response?.data?.errors;
        if (errorData && Object.keys(errorData).length > 0) {
          for (let key in errorData) {
            for (let e of errorData[key]) {
              addToast(e, {
                appearance: 'error',
                autoDismiss: true,
              });
              setLoading(false);
            }
          }
        } else if (err.response?.data?.code === 404) {
          addToast('No Update Api.', {
            appearance: 'error',
            autoDismiss: true,
          });
          history.push('/companies');
        } else {
          addToast(err.response?.data?.message, {
            appearance: 'error',
            autoDismiss: true,
          });

          setLoading(false);
        }
      });
  };

  const handleUpdateCompanyDetails = () => {
    const isFormValid = validateFormSubmission();

    if (isFormValid) {
      setLoading(true);
      if (hasFileModified) {
        uploadImage()
          .then((imageResponseData) => {
            if (imageResponseData) {
              if (imageResponseData.code === 200) {
                const dataPayload = {
                  image_id: imageResponseData.data?.id,
                  name: companyName,
                  status: companyStatus,
                  sub_domain: subDomain,
                  aocs: selectedAocOptions,
                  is_dashboard_visible: dashboardVisible,
                  auto_premium: premium,
                  membership_code: coupon,
                };

                submitCompanyDetails(dataPayload);
              }
            }
          })
          .catch((uploadErrorData) => {
            setLoading(false);
            addToast('Could not Upload Image', {
              appearance: 'error',
              autoDismiss: true,
            });
          });
      } else {
        const dataPayload = {
          image_id: companyImageIdentifier,
          name: companyName,
          status: companyStatus,
          sub_domain: subDomain,
          aocs: selectedAocOptions,
          is_dashboard_visible: dashboardVisible,
          auto_premium: premium,
          membership_code: coupon,
        };

        submitCompanyDetails(dataPayload);
      }
    } else {
      setLoading(false);
    }
  };

  const handleDeleteCompany = (status, identifier) => {
    let data = { status: '' };
    if (status === 'ACTIVE') {
      data.status = 'INACTIVE';
      // setCompanyStatus('INACTIVE')
    } else if (status === 'INACTIVE') {
      data.status = 'ACTIVE';
      // setCompanyStatus('ACTIVE')
    }
    const companyIdIdentifier = identifier;
    if (companyIdIdentifier) {
      updateCompanyStatusService(companyIdIdentifier, data)
        .then((response) => {
          if (response.code === 200) {
            setLoading(false);

            addToast('Company status has been changed successfully.', {
              appearance: 'success',
              autoDismiss: true,
            });

            // TODO: Handle Response Using Response Code
            history.push('/companies');
          }
        })
        .catch((err) => {
          setLoading(false);

          addToast(err.response?.data?.message, {
            appearance: 'error',
            autoDismiss: true,
          });
        });
    }
  };

  return (
    <div className='company-wrapper'>
      <Header userData={userData} />

      <Sidebar />

      <div className='flexible-container'>
        <SubHeader
          title='Edit Company Details'
          // subtitle={ (companyName && `Name: ${companyName}`) || 'Name: Untitled Company'}
        />

        <div className='company-wrapper-content'>
          <div className='form-section'>
            <div className='row'>
              <div className='col-12 col-sm-6 col-md-4'>
                <div className='input-wrapper-display'>
                  <img
                    src={image ? image : Placeholder}
                    className='display-image'
                    alt='Uploaded File'
                  />
                </div>

                <Input
                  type='file'
                  name='authorPhoto'
                  required='yes'
                  handleChange={handleImageSelection}
                  label='Upload Photo (1:1 Circular Corners)'
                  accept='.jpg, .png, .jpeg, .webp'
                />
              </div>
            </div>

            <div className='row'>
              <div className='col-12 col-sm-6'>
                <Input
                  name='companyName'
                  value={companyName}
                  label={'Company Name'}
                  placeholder='Title of the post'
                  handleChange={handleFieldUpdate}
                  required='yes'
                />
              </div>
            </div>

            <div className='row'>
              <div className='col-12 col-sm-6'>
                <Input
                  name='companySubdomain'
                  value={subDomain}
                  label={'Sub Domain'}
                  placeholder='Sub Domain of the company'
                  handleChange={handleFieldUpdate}
                  required='yes'
                />
              </div>

              <div className='col-12 col-sm-6'>
                <Input
                  name='couponCode'
                  value={coupon}
                  label={'Unique code'}
                  placeholder='Enter Text'
                  handleChange={handleFieldUpdate}
                  required='yes'
                />
              </div>
            </div>

            <div className='row'>
              <div className='col-12 col-sm-6 col-md-4'>
                <DropdownSelect
                  value={dashboardVisible}
                  options={dashboardVisibleStatus}
                  label={'Dashboard Visible'}
                  placeholder='Choose status'
                  handleChange={handleDashboardVisible}
                />
              </div>

              <div className='col-12 col-sm-6 col-md-4'>
                <DropdownSelect
                  value={premium}
                  options={autoPremiumStatus}
                  label={'Are all users members by default?'}
                  placeholder='Choose status'
                  handleChange={handleAutoPremium}
                />
              </div>
            </div>

            {/* <div className='row'>
              <div className='col-12 col-sm-6 col-md-4'>
                <DropdownSelect
                  value={companyStatus}
                  options={listingOptions}
                  label={'Company Listing Status'}
                  placeholder='Choose status'
                  handleChange={handleStatusSelection}
                  required='yes'
                /> 
              </div>
            </div> */}

            <div className='row'>
              <div className='col-12 col-sm-6 col-md-4'>
                <MultiDropdownSelect
                  options={aocOptions}
                  label={'Choose Area Of Contents'}
                  placeholder='Choose contents'
                  handleChange={handleAocSelection}
                  // required='yes'
                  selectedList={selectedAocOptions}
                />
              </div>
            </div>

            <div className='row'>
              <div className='col-12 col-sm-6 col-md-4'>
                <PrimaryButton
                  value='Save'
                  className='spaced-button'
                  handleClick={handleUpdateCompanyDetails}
                />
              </div>

              <div className='col-12 col-sm-6 text-right'>
                <SecondaryButton
                  value={
                    companyStatus === 'ACTIVE' ? 'MAKE INACTIVE' : 'MAKE ACTIVE'
                  }
                  className={
                    companyStatus === 'ACTIVE'
                      ? 'danger-button'
                      : 'success-button'
                  }
                  handleClick={() =>
                    handleDeleteCompany(companyStatus, companyIdentifier)
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading && <Spinner />}
    </div>
  );
};

export default EditCompanies;
